/** @file Inserts a key into a frame-sorted list: a push when it lands last, never a splice. */

/**
 * Puts `key` after the keys at or before its frame. When no key lies later it is pushed onto `keys` (one `add` patch,
 * R17-01); otherwise, or when there is no list yet, `write` stores a new array for this list only.
 */
export function insertByFrame<K extends { f: number }>(keys: K[] | undefined, key: K, write: (next: K[]) => void): void {
  if (keys === undefined) write([key]);
  else if ((keys.at(-1)?.f ?? -1) <= key.f) keys.push(key);
  else write([...keys.filter((k) => k.f <= key.f), key, ...keys.filter((k) => k.f > key.f)]);
}
